import Flex from 'antd/es/flex'
import Spin from "antd/es/spin"

export const Fallback = () => <Flex style={{ height: '100%' }} align="center" justify="space-around">
    <Spin size="large"/>
</Flex>
